<template>
    <Draggable v-if="multiAVModalVisible" id="drag3">
        <div class="multiAVModal" v-show="multiAVModalVisible">
            <span class="title">{{resetName(to.groupname)}}</span>
            <!-- <div>时间</div> -->
            <el-row type="flex" class="row-bg" justify="space-around">
                <el-col :span="6"><div class="grid-content bg-purple videoBox">
                    <video class="video" autoPlay playsInline muted ref="rv_local"/>
                    <div class="tools">
                        <span>{{resetName(rv_local.nickName)}}</span>
                    </div>
                </div></el-col>
                <el-col :span="6"><div class="grid-content bg-purple-light videoBox">
                    <video class="video" autoPlay playsInline ref="rv_0"/>
                    <div class="tools">
                        <span>{{resetName(rv[0].nickName)}}</span>
                        <i class="el-icon-video-camera red" @click="controlRemoteVideo(0)"></i>
                    </div>
                </div></el-col>
                <el-col :span="6"><div class="grid-content bg-purple videoBox">
                    <video class="video" autoPlay playsInline ref="rv_1"/>
                    <div class="tools">
                        <span>{{resetName(rv[1].nickName)}}</span>
                        <i class="el-icon-video-camera red" @click="controlRemoteVideo(1)"></i>
                    </div>
                </div></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-around">
                <el-col :span="6"><div class="grid-content bg-purple videoBox">
                    <video class="video" autoPlay playsInline ref="rv_2"/>
                    <div class="tools">
                        <span>{{resetName(rv[2].nickName)}}</span>
                        <i class="el-icon-video-camera red" @click="controlRemoteVideo(2)"></i>
                    </div>
                </div></el-col>
                <el-col :span="6"><div class="grid-content bg-purple-light videoBox">
                    <video class="video" autoPlay playsInline ref="rv_3"/>
                    <div class="tools">
                        <span>{{resetName(rv[3].nickName)}}</span>
                        <i class="el-icon-video-camera red" @click="controlRemoteVideo(3)"></i>
                    </div>
                </div></el-col>
                <el-col :span="6"><div class="grid-content bg-purple videoBox">
                    <video class="video" autoPlay playsInline ref="rv_4"/>
                    <div class="tools">
                        <span>{{rv[4].nickName}}</span>
                        <i class="el-icon-video-camera red" @click="controlRemoteVideo(4)"></i>
                    </div>
                </div></el-col>
            </el-row>
            <div class="toolsBox">
                <el-col :span="3"><i class="el-icon-circle-plus-outline toolBtn" @click="invite"></i></el-col>
                <el-col :span="3">
									<i :class="rv_local.openAudio?'toolBtn':'active'" @click="controlLocalMic">
										<svg class="svg" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10962"><path d="M499.77 39.58a27.78 27.78 0 0 0-29.08 2.63l-291 218.21H39.78A27.76 27.76 0 0 0 12 288.2v447.59a27.76 27.76 0 0 0 27.78 27.78h139.94l291 218.21a27.58 27.58 0 0 0 16.66 5.56 27.77 27.77 0 0 0 27.78-27.78V64.43a27.79 27.79 0 0 0-15.39-24.85zM459.56 904L205.63 713.58A27.7 27.7 0 0 0 189 708H67.56V316H189a27.7 27.7 0 0 0 16.66-5.56L459.56 120zM856.84 512l147-147a27.77 27.77 0 0 0-39.28-39.28l-147 147-147-147A27.77 27.77 0 0 0 631.25 365l147 147-147 147a27.77 27.77 0 1 0 39.28 39.28l147-147 147 147a27.77 27.77 0 1 0 39.33-39.28z" p-id="10963"></path></svg>
									</i>
								</el-col>
                <el-col :span="3">
									<i :class="rv_local.openVideo?'toolBtn':'active'" @click="controlLocalVideo">
										<svg class="svg" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6929"><path d="M290.370435 380.792133C282.629994 402.20722 262.311836 417.592195 238.628964 417.592195h-1.722318C206.610232 417.592195 181.822439 392.41678 181.822439 361.646829c0-24.225342 15.364995-44.983071 36.686174-52.717518l71.861822 71.862822zM164.329522 254.75122H129.873171v513.498536h547.465366v-0.489522l54.827457 54.827458A31.870876 31.870876 0 0 1 709.307317 832.187317H97.90439c-17.682732 0-31.96878-14.286049-31.96878-31.96878V222.782439c0-17.682732 14.286049-31.96878 31.96878-31.96878h3.914178a64.321186 64.321186 0 0 0 7.329842 8.756448L164.329522 254.75122z m180.843395 0l-63.937561-63.937561H709.307317c17.682732 0 31.96878 14.286049 31.968781 31.96878v217.787317l167.836097-138.564683c21.27922-12.288 47.953171 3.096976 47.953171 27.672976v363.74478c0 24.476098-26.673951 39.861073-47.953171 27.573073L741.276098 584.429268v66.425132l-63.937561-63.937561V254.75122H345.172917zM741.276098 511.500488l151.851707 120.881951V390.618537L741.276098 511.500488zM87.54151 87.54151c12.484808-12.483809 32.726041-12.483809 45.210849 0l801.783009 801.784008c12.484808 12.483809 12.484808 32.726041 0 45.20985-12.483809 12.484808-32.726041 12.484808-45.20985 0L87.54151 132.752359c-12.483809-12.484808-12.483809-32.726041 0-45.210849z" p-id="6930"></path></svg>
									</i>
								</el-col>
								<el-button type="danger" size="mini" @click="closeModal">挂断</el-button>
            </div>
        </div>
    </Draggable>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Draggable from "../draggable";
export default{
	data(){
		return {
			// emediaModalVisible: false
			rv_local: {
				nickName: "",
				streamId: "",
				openAudio: false,
				openVideo: false,
				video: <div className="default"></div>
			},
			rv: new Array(5).fill({
				nickName: "",
				streamId: "",
				openVideo: false,
				video: <div className="default"></div>
			}),
			rvCount: 0,
		};
	},
	props: [
		"to"
	],
	computed: {
		multiAVModalVisible(){
			return this.$store.state.emedia.multiAVModalVisible;
		},
		addAVMemberModalVisible(){
			return this.$store.state.emedia.addAVMemberModalVisible;
		}
	},
	mounted(){
		this.initEmedia();
	},
	methods: {
		...mapActions([
			"showMultiAVModal",
			"hideMultiAVModal",
			"setConfr",
			"setAVMemeberModalVisible"
		]),
		//删除名称前缀
		resetName(value){
			let str='';
			if(value){
				let arr=value.split('-');
				if(arr.length > 1) {
				arr.splice(0,1);
				str=arr.join('-');
				}else {
				return value
				}
			}
			return str;
		},
		initEmedia(){
			let me = this;
			this.$IM.EMService = this.$IM.EMedia.mgr;
			this.$IM.EMService.onConferenceExit = function(reason, failed){
				reason = reason || 0;
				switch(reason){
				case 0:
					reason = "正常挂断";
					break;
				case 1:
					reason = "没响应";
					break;
				case 2:
					reason = "服务器拒绝";
					break;
				case 3:
					reason = "对方忙";
					break;
				case 4:
					reason = "失败,可能是网络或服务器拒绝";
					if(failed === -9527){
						reason = "失败,网络原因";
					}
					if(failed === -500){
						reason = "Ticket失效";
					}
					if(failed === -502){
						reason = "Ticket过期";
					}
					if(failed === -504){
						reason = "链接已失效";
					}
					if(failed === -508){
						reason = "会议无效";
					}
					break;
				case 5:
					reason = "不支持";
					break;
				case 10:
					reason = "其他设备登录";
					break;
				case 11:
					reason = "会议关闭";
					break;
				default:
					break;
				}
				console.log("Hangup reason " + (reason || 0));
			};

			this.$IM.EMService.onMemberJoined = function(member){
				me.$message.success(member.name + " 加入群聊.");
				// me.props.setJoinedMembers(member)
			};
			this.$IM.EMService.onMemberExited = function(member, reason){
				// me.removeVideo(member.name)

				// 用户主动挂断时，不提示退出群聊
				if(reason !== undefined){
					me.$message.warning(member.name + " 退出群聊.");
				}
				// me.props.updateJoinedMembers(member)
			};

			this.$IM.EMService.onRoleChanged = function(role){ // emedia.mgr.Role
				// TODO 在直播模式下，如果变为主播，请上麦 publish stream
			};
			this.$IM.EMService.onStreamAdded = function(member, stream){
				const located = stream.located();
				console.log("来流了", stream.located());
				let index;
				if(located){
					let localVideo = me.$refs.rv_local;
					const nickName = member.name;
					let lv = {
						nickName,
						stream: stream,
						localStreamId: stream.id,
						openVideo: true,
						openAudio: true,
					};
					me.$data.rv_local = lv;

					me.$IM.EMedia.mgr.onMediaChanaged(localVideo, function(constaints){
						let lv = {
							nickName,
							stream: stream,
							localStreamId: stream.id,
							openVideo: constaints.video,
							openAudio: constaints.audio,
						};
						me.$data.rv_local = lv;
						// console.warn(stream.id, "voff:", me.getAttribute("voff"));
						// console.warn(stream.id, "aoff:", me.getAttribute("aoff"));
					});
					me.$IM.EMedia.mgr.streamBindVideo(stream, localVideo);

				}
				else{
					let rv = me.$data.rv, rvCount = me.$data.rvCount;
					const nickName = member.name,
						streamId = stream.id;
					const contains = (nickName, arr) => {
						for(let [ index, elem ] of arr.entries()){
							if(elem.nickName === nickName){
								return index;
							}
						}
						return false;
					};

					const ifContain = contains(nickName, rv);
					if(ifContain === false){
						
						// 从0～5看哪个位置空着，就往哪里添加
						for(let i = 0; i < 5; i++){
							if(rv[i].nickName == ""){
								index = i;
								if(index || index == 0){
									break;
								}
							}
						}
						rvCount++;
						let video = me.$refs["rv_" + index];

						console.log("别人的video标签", video, index);
						const elem = {
							nickName: nickName,
							streamId: streamId,
							openVideo: true,
							video: rv[index].video
						};
						rv[index] = elem;
						me.$data.rv = rv;
						me.$data.rvCount = rvCount;

						me.$IM.EMedia.mgr.onMediaChanaged(video, function(constaints){
							
							const elem = {
								nickName: nickName,
								streamId: streamId,
								openVideo: constaints.video,
								video: rv[index].video
							};
							rv[index] = elem;
							me.$data.rv = rv;
							console.log("别人的video ++++", elem);
							console.log(rv);
							// console.warn(streamId, "voff:", me.getAttribute("voff"));
							// console.warn(streamId, "aoff:", me.getAttribute("aoff"));
						});
						me.$forceUpdate();
						me.$IM.EMedia.mgr.streamBindVideo(stream, video);
						me.$IM.EMedia.mgr.subscribe(member, stream, true, true, video);
					}
				}
			};
			this.$IM.EMService.onStreamRemoved = function(member, stream){
			};
		},
		closeModal(){
			// clearInterval(this.state.interval)
			this.$IM.EMService.exitConference();
			this.hideMultiAVModal();
			this.setConfr("");
			this.$data.rv_local = {
				nickName: "",
				streamId: "",
				openAudio: false,
				openVideo: false,
				video: <div className="default"></div>
			};
			this.$data.rv = new Array(5).fill({
				nickName: "",
				streamId: "",
				openVideo: false,
				video: <div className="default"></div>
			});
			this.$data.rvCount = 0;
			// this.props.resetConfr()
		},
        
		controlRemoteVideo(id){
			// let rv = _.cloneDeep(this.state.rv)
			let rv = this.$data.rv;
			let elem = rv[id];
			if(elem.streamId === ""){
				return;
			}
			let video = this.$refs["rv_" + id];
			if(elem.openVideo){
				this.$IM.EMedia.mgr.triggerPauseVideo(video);
			}
			else{
				this.$IM.EMedia.mgr.triggerResumeVideo(video);
			}
		},
		controlLocalVideo(){
			let localVideo = this.$refs.rv_local;
			let { stream, localStreamId, openAudio, openVideo } = this.$data.rv_local;
			if(openVideo){
				this.$IM.EMedia.mgr.triggerPauseVideo(localVideo);
			}
			else{
				this.$IM.EMedia.mgr.triggerResumeVideo(localVideo);
			}
		},
		controlLocalMic(){
			let localVideo = this.$refs.rv_local;
			let { stream, localStreamId, openAudio, openVideo } = this.$data.rv_local;
			if(openAudio){
				this.$IM.EMedia.mgr.triggerPauseAudio(localVideo);
			}
			else{
				this.$IM.EMedia.mgr.triggerResumeAudio(localVideo);
			}
		},
		invite(){
			this.setAVMemeberModalVisible({ addAVMemberModalVisible: true });
		}

	},

	components: {
		Draggable
	},
};
</script>
<style scoped lang="scss">
@import "./index.scss";
    .multiAVModal{
        width: 100%;
        height: 450px;
        background: #fff;
        padding: 16px;
        box-shadow: 0 0 10px #ADB9C1;
    }

    .el-row {
    margin-bottom: 20px;
    /* &:last-child {
      margin-bottom: 0;
    } */
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 140px;
  }
  .row-bg {
    padding: 5px 0;
    background-color: #f9fafc;
  }
  .video{
    height: 139px;
    width: 100%;
    border-radius: 2px;
  }
  /* .hangup{
         width: 50px;
        height: 30px;
        text-align: center;
        padding: 0;
  } */
  .red{
    color: red;
    float: right;
    margin-right: 12px;
  }
  .videoBox{
      position: relative;
  }
  .tools{
      position: absolute;
      width: 100%;
      bottom: 0;
			span{
				font-size: 12px;
				color: #fff;
			}
  }
  .toolsBox{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		justify-content: space-between;
  }
  .title{
		font-size: 18px;
    color: #333;
    line-height: 33px;
    font-weight: 400;
    display: block;
    text-align: start;
    padding: 5px 12px;
    box-sizing: border-box
  }
  .active{
      color: rgba(83, 90, 93, 1);
      font-size: 32px;
  }
    .toolBtn{
        color: rgba(83, 90, 93, 0.6);
        font-size: 32px;
    }
</style>
